import { Button } from "aible";
import React from "react";
import { toast } from "react-toastify";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import styles from "./style.module.css";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

const DEFAULT_STATE = {
  showModal: false,
  isLoading: false,
  datasetJSON: undefined
};

export default class ExportJSON extends React.Component {
  state = { ...DEFAULT_STATE };
  handleClose() {
    const { handleClose } = this.props;
    if (handleClose !== undefined) {
      return handleClose();
    }
    this.setState({ ...DEFAULT_STATE });
  }
  handleOpen() {
    const { onClick, handleOpen } = this.props;
    if (handleOpen !== undefined) {
      return handleOpen();
    }
    this.setState({ showModal: true });
    return onClick && onClick();
  }
  handleFetch() {
    const { fetchDatasetJSON } = this.props;
    this.setState({ isLoading: true });
    return fetchDatasetJSON().then((dJSON) => {
      this.setState({ isLoading: false, datasetJSON: dJSON });
      return dJSON;
    });
  }
  render() {
    const { show, noButton, children, ...retProps } = this.props;
    const { showModal, isLoading, datasetJSON } = this.state;

    return (
      <React.Fragment>
        {!noButton && (
          <Button onClick={() => this.handleOpen()} {...retProps}>
            {children ? children : "Access Datasets"}
          </Button>
        )}
        <ExportModal
          {...retProps}
          showModal={show !== undefined ? show : showModal}
          isLoading={isLoading}
          datasetJSON={datasetJSON}
          handleFetch={() => this.handleFetch()}
          handleClose={() => this.handleClose()}
        />
      </React.Fragment>
    );
  }
}

class ExportModal extends React.PureComponent {
  handleCopy(text, label) {
    toast(label + " copied to clipboard.", {
      type: toast.TYPE.SUCCESS,
      position: toast.POSITION.TOP_CENTER,
      autoClose: 3500
    });
    navigator.clipboard.writeText(text);
  }
  render() {
    const {
      id,
      datasetName,
      datasetUrl,
      showModal,
      isLoading,
      datasetJSON,
      handleClose,
      handleFetch,
      isLinkedDataset
    } = this.props;
    return (
      <Dialog open={showModal} onOpenChange={handleClose}>
        <DialogContent size="xl">
          <DialogHeader>
            <DialogTitle>{datasetName ? datasetName : "Access Datasets"}</DialogTitle>
          </DialogHeader>
          {id && (
            <div className={styles.exportModalItem}>
              <div className={styles.exportModalItemTitle}>
                <div className={styles.exportModalSubtitle}>
                  {isLinkedDataset ? "Credentials Location" : "Dataset Location"}
                </div>
                <Button
                  type={"secondary"}
                  style={{ marginLeft: "10px" }}
                  onClick={() => this.handleCopy(datasetUrl, isLinkedDataset ? "Credentials URL" : "Dataset URL")}
                >
                  {"Copy URL to Clipboard"}
                </Button>
              </div>
              <a className={styles.exportModalText} href={datasetUrl} target="_blank">
                {datasetUrl}
              </a>
            </div>
          )}
          <div className={styles.exportModalItem}>
            <div className={styles.exportModalItemTitle}>
              <div className={styles.exportModalSubtitle}>{"Export Schema as JSON"}</div>
              {!isLoading && datasetJSON !== undefined && (
                <Button
                  type={"secondary"}
                  style={{ marginLeft: "10px" }}
                  onClick={() => this.handleCopy(datasetJSON, "Dataset JSON")}
                >
                  {"Copy JSON to Clipboard"}
                </Button>
              )}
            </div>
            {isLoading ? (
              <div className={styles.exportModalText}>
                <LoadingIndicator />
              </div>
            ) : datasetJSON === undefined ? (
              <div
                className={styles.exportModalText}
                style={{
                  alignItems: "flex-start",
                  justifyContent: "flex-start"
                }}
              >
                <Button style={{ marginTop: "10px" }} type={"primary"} onClick={handleFetch}>
                  {"Generate JSON"}
                </Button>
              </div>
            ) : (
              <textarea className={styles.exportModalTextBox} name="dataset-json" value={datasetJSON} readOnly />
            )}
          </div>
          <DialogFooter className={styles.exportModalFooter}>
            <Button type={"secondary"} onClick={handleClose} style={{ marginLeft: "auto" }}>
              {"Close"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }
}
